<div class="card kpi-blue">
    <div class="card-body kpi-card">
        <h5 class="card-title">Loyer moyen au m²
            <i class="fa fa-question-circle" matTooltip="Loyer moyen des {{(favorite.ad_city.loyer_moyen_ville.A.lM==0? (favorite.ad_city.loyer_moyen_petite_ville.lM==0? (favorite.ad_city.loyer_moyen_petite_ville_cp.lM==0? '-':
        'appartements et maisons confondus sur le code postal à '+ favorite.ad_city.zip_code ) : 'appartements et maisons confondus à '+ favorite.ad_city.name): 'appartements à '+ favorite.ad_city.name) }}"></i>
        </h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- €/m²</ng-container>
            <ng-container *ngIf="!preview">
                {{ (favorite.ad_city.loyer_moyen_ville.A.lM == 0 ? (favorite.ad_city.loyer_moyen_petite_ville.lM == 0 ? (favorite.ad_city.loyer_moyen_petite_ville_cp.lM == 0 ? "-" : favorite.ad_city.loyer_moyen_petite_ville_cp.lM) : favorite.ad_city.loyer_moyen_petite_ville.lM) : favorite.ad_city.loyer_moyen_ville.A.lM) | number:'1.1-1'  }}
                €/m²
            </ng-container>
        </p>
    </div>
</div>
